import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import AbstractCommand from "../../application/AbstractCommand";
import SystemMessageBuilder from "../../system-message/controller/SystemMessageBuilder";
import SystemMessageEvent from "../../system-message/model/SystemMessageEvent";
import AssetLoadServiceEvent from "../events/AssetLoadServiceEvent";

export default class PromptRetryLoadingAssetsCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(dispatcher, languagePack) {
        super(dispatcher);

        this._languagePack = languagePack;
    }

    execute(evt) {
        const data = evt.params.data.data;
        const filesThatFailedToLoad = data.files;
        const reloadPageOnRetry = data.reloadPageOnRetry;

        console.warn("Some files failed to load: ", filesThatFailedToLoad);
        console.warn("Reload page on retry: ", reloadPageOnRetry);

        const systemMessage = this._getFileLoadErrorSystemMessage(() => {
            if (reloadPageOnRetry) {
                this.dispatch(AssetLoadServiceEvent.RETRY_LOADING_FAILED_ITEMS);
            } else {
                location.reload();
            }
        });
        const systemMessageEvt = new SystemMessageEvent(SystemMessageEvent.OPEN, systemMessage);
        this.dispatch(systemMessageEvt.type, { data: systemMessageEvt });

        this._handleLoadCompleteBound = this._handleLoadComplete.bind(this);
        this._dispatcher.addEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, this._handleLoadCompleteBound);
    }

    _handleLoadComplete(evt) {
        this._dispatcher.removeEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, this._handleLoadCompleteBound);

        this._dispatcher.dispatch(SystemMessageEvent.DISMISS_ALL);

        const systemMessage = this._getFileLoadSuccessSystemMessage();
        const systemMessageEvt = new SystemMessageEvent(SystemMessageEvent.OPEN, systemMessage);
        this.dispatch(systemMessageEvt.type, { data: systemMessageEvt });
    }

    _getFileLoadErrorSystemMessage(callback) {
        return new SystemMessageBuilder()
            .setTitle(this._languagePack.getText('assetLoading.fileLoadError.title'))
            .setDescription(this._languagePack.getText('assetLoading.fileLoadError.description'))
            .addOption({
                text: this._languagePack.getText('assetLoading.fileLoadError.okButtonLabel'),
                callback
            })
            .build();
    }

    _getFileLoadSuccessSystemMessage(callback) {
        return new SystemMessageBuilder()
            .setTitle(this._languagePack.getText('assetLoading.fileLoadSuccess.title'))
            .setDescription(this._languagePack.getText('assetLoading.fileLoadSuccess.description'))
            .addOption({
                text: this._languagePack.getText('assetLoading.fileLoadSuccess.okButtonLabel'),
                callback
            })
            .build();
    }
}